import VueSingleSelect from './VueSingleSelect.vue';
export default VueSingleSelect;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-single-select/dist/index.js
// module id = 6EBc
// module chunks = 1